import { save as Jt } from "@tauri-apps/plugin-dialog";
import { writeTextFile as qt, writeFile as er } from "@tauri-apps/plugin-fs";
import { open as tr } from "@tauri-apps/plugin-shell";
import Ne from "axios";
function bt(t, e, r, n, s, a, i, o, c) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return r(e(t));
    case 4:
      return n(r(e(t)));
    case 5:
      return s(n(r(e(t))));
    case 6:
      return a(s(n(r(e(t)))));
    case 7:
      return i(a(s(n(r(e(t))))));
    case 8:
      return o(i(a(s(n(r(e(t)))))));
    case 9:
      return c(o(i(a(s(n(r(e(t))))))));
    default: {
      for (var u = arguments[0], p = 1; p < arguments.length; p++)
        u = arguments[p](u);
      return u;
    }
  }
}
var rr = function(t) {
  return { _tag: "Left", left: t };
}, nr = function(t) {
  return { _tag: "Right", right: t };
}, sr = function(t) {
  return t.length > 0;
}, ar = function(t) {
  return t[0];
}, xt = Object.prototype.hasOwnProperty, ir = sr, or = ar, ut = or, cr = function(t) {
  return t[t.length - 1];
}, Ge = function(t) {
  return function(e) {
    var r = e.split(t);
    return ir(r) ? r : [e];
  };
};
const dr = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    async saveFileWithDialog(t) {
      const e = new Blob([t.data], { type: t.contentType }), r = document.createElement("a"), n = URL.createObjectURL(e);
      return r.href = n, r.download = t.suggestedFilename ?? bt(
        n,
        Ge("/"),
        cr,
        Ge("#"),
        ut,
        Ge("?"),
        ut
      ), document.body.appendChild(r), r.click(), setTimeout(() => {
        document.body.removeChild(r), URL.revokeObjectURL(n);
      }, 1e3), { type: "unknown" };
    },
    async openExternalLink(t) {
      return window.open(t.url, "_blank"), { type: "unknown" };
    },
    async listen(t, e) {
      const r = (n) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", r), () => window.removeEventListener("hashchange", r);
    },
    async once(t, e) {
      const r = (n) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          window.removeEventListener("hashchange", r), e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", r), () => window.removeEventListener("hashchange", r);
    },
    async emit(t, e) {
      window.location.hash = `${t}:${JSON.stringify(e)}`;
    }
  }
}, ur = {
  v1: dr
};
function lr(t, e, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}
function hr(t, e, r, n, s) {
  if (typeof e == "function" ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Ce;
function fr(t, e = !1) {
  return window.__TAURI_INTERNALS__.transformCallback(t, e);
}
async function A(t, e = {}, r) {
  return window.__TAURI_INTERNALS__.invoke(t, e, r);
}
class pr {
  get rid() {
    return lr(this, Ce, "f");
  }
  constructor(e) {
    Ce.set(this, void 0), hr(this, Ce, e);
  }
  /**
   * Destroys and cleans up this resource from memory.
   * **You should not call any method on this object anymore and should drop any reference to it.**
   */
  async close() {
    return A("plugin:resources|close", {
      rid: this.rid
    });
  }
}
Ce = /* @__PURE__ */ new WeakMap();
var lt;
(function(t) {
  t.WINDOW_RESIZED = "tauri://resize", t.WINDOW_MOVED = "tauri://move", t.WINDOW_CLOSE_REQUESTED = "tauri://close-requested", t.WINDOW_DESTROYED = "tauri://destroyed", t.WINDOW_FOCUS = "tauri://focus", t.WINDOW_BLUR = "tauri://blur", t.WINDOW_SCALE_FACTOR_CHANGED = "tauri://scale-change", t.WINDOW_THEME_CHANGED = "tauri://theme-changed", t.WINDOW_CREATED = "tauri://window-created", t.WEBVIEW_CREATED = "tauri://webview-created", t.DRAG_ENTER = "tauri://drag-enter", t.DRAG_OVER = "tauri://drag-over", t.DRAG_DROP = "tauri://drag-drop", t.DRAG_LEAVE = "tauri://drag-leave";
})(lt || (lt = {}));
async function mr(t, e) {
  await A("plugin:event|unlisten", {
    event: t,
    eventId: e
  });
}
async function je(t, e, r) {
  var n;
  const s = (n = void 0) !== null && n !== void 0 ? n : { kind: "Any" };
  return A("plugin:event|listen", {
    event: t,
    target: s,
    handler: fr(e)
  }).then((a) => async () => mr(t, a));
}
async function yr(t, e) {
  await A("plugin:event|emit", {
    event: t,
    payload: e
  });
}
const gr = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    async saveFileWithDialog(t) {
      const e = await Jt({
        filters: t.filters,
        defaultPath: t.suggestedFilename
      });
      return e ? (typeof t.data == "string" ? await qt(e, t.data) : await er(e, t.data), { type: "saved", path: e }) : { type: "cancelled" };
    },
    async openExternalLink(t) {
      return await tr(t.url), { type: "opened" };
    },
    async listen(t, e) {
      return await je(t, e);
    },
    async once(t, e) {
      const r = await je(t, (n) => {
        r(), e(n);
      });
      return r;
    },
    async emit(t, e) {
      await yr(t, e);
    }
  }
}, vr = {
  v1: gr
};
var w = rr, O = nr, Tt = /* @__PURE__ */ ((t) => (t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data", t))(Tt || {});
const St = {
  body: (t, e) => ({
    body: new Uint8Array(t),
    mediaType: typeof e == "string" ? Object.values(Tt).find((r) => e.includes(r)) ?? "application/octet-stream" : e ?? "application/octet-stream"
    /* APPLICATION_OCTET */
  })
}, ws = {
  text: (t, e) => ({
    kind: "text",
    content: t,
    mediaType: e ?? "text/plain"
    /* TEXT_PLAIN */
  }),
  json: (t, e) => ({
    kind: "json",
    content: t,
    mediaType: e ?? "application/json"
    /* APPLICATION_JSON */
  }),
  xml: (t, e) => ({
    kind: "xml",
    content: t,
    mediaType: e ?? "application/xml"
    /* APPLICATION_XML */
  }),
  form: (t) => ({
    kind: "form",
    content: t,
    mediaType: "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  binary: (t, e = "application/octet-stream", r) => ({
    kind: "binary",
    content: t,
    mediaType: e,
    filename: r
  }),
  multipart: (t) => ({
    kind: "multipart",
    content: t,
    mediaType: "multipart/form-data"
    /* MULTIPART_FORM */
  }),
  urlencoded: (t) => ({
    kind: "urlencoded",
    content: t,
    mediaType: "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  stream: (t, e) => ({
    kind: "stream",
    content: t,
    mediaType: e
  })
};
/**
 * @license MIT <https://opensource.org/licenses/MIT>
 * @copyright Michael Hart 2024
 */
const qe = new TextEncoder(), _r = {
  appstream2: "appstream",
  cloudhsmv2: "cloudhsm",
  email: "ses",
  marketplace: "aws-marketplace",
  mobile: "AWSMobileHubService",
  pinpoint: "mobiletargeting",
  queue: "sqs",
  "git-codecommit": "codecommit",
  "mturk-requester-sandbox": "mturk-requester",
  "personalize-runtime": "personalize"
}, wr = /* @__PURE__ */ new Set([
  "authorization",
  "content-type",
  "content-length",
  "user-agent",
  "presigned-expires",
  "expect",
  "x-amzn-trace-id",
  "range",
  "connection"
]);
class kr {
  constructor({ method: e, url: r, headers: n, body: s, accessKeyId: a, secretAccessKey: i, sessionToken: o, service: c, region: u, cache: p, datetime: T, signQuery: K, appendSessionToken: x, allHeaders: b, singleEncode: R }) {
    if (r == null) throw new TypeError("url is a required option");
    if (a == null) throw new TypeError("accessKeyId is a required option");
    if (i == null) throw new TypeError("secretAccessKey is a required option");
    this.method = e || (s ? "POST" : "GET"), this.url = new URL(r), this.headers = new Headers(n || {}), this.body = s, this.accessKeyId = a, this.secretAccessKey = i, this.sessionToken = o;
    let re, M;
    (!c || !u) && ([re, M] = br(this.url, this.headers)), this.service = c || re || "", this.region = u || M || "us-east-1", this.cache = p || /* @__PURE__ */ new Map(), this.datetime = T || (/* @__PURE__ */ new Date()).toISOString().replace(/[:-]|\.\d{3}/g, ""), this.signQuery = K, this.appendSessionToken = x || this.service === "iotdevicegateway", this.headers.delete("Host"), this.service === "s3" && !this.signQuery && !this.headers.has("X-Amz-Content-Sha256") && this.headers.set("X-Amz-Content-Sha256", "UNSIGNED-PAYLOAD");
    const W = this.signQuery ? this.url.searchParams : this.headers;
    if (W.set("X-Amz-Date", this.datetime), this.sessionToken && !this.appendSessionToken && W.set("X-Amz-Security-Token", this.sessionToken), this.signableHeaders = ["host", ...this.headers.keys()].filter((I) => b || !wr.has(I)).sort(), this.signedHeaders = this.signableHeaders.join(";"), this.canonicalHeaders = this.signableHeaders.map((I) => I + ":" + (I === "host" ? this.url.host : (this.headers.get(I) || "").replace(/\s+/g, " "))).join(`
`), this.credentialString = [this.datetime.slice(0, 8), this.region, this.service, "aws4_request"].join("/"), this.signQuery && (this.service === "s3" && !W.has("X-Amz-Expires") && W.set("X-Amz-Expires", "86400"), W.set("X-Amz-Algorithm", "AWS4-HMAC-SHA256"), W.set("X-Amz-Credential", this.accessKeyId + "/" + this.credentialString), W.set("X-Amz-SignedHeaders", this.signedHeaders)), this.service === "s3")
      try {
        this.encodedPath = decodeURIComponent(this.url.pathname.replace(/\+/g, " "));
      } catch {
        this.encodedPath = this.url.pathname;
      }
    else
      this.encodedPath = this.url.pathname.replace(/\/+/g, "/");
    R || (this.encodedPath = encodeURIComponent(this.encodedPath).replace(/%2F/g, "/")), this.encodedPath = pt(this.encodedPath);
    const Oe = /* @__PURE__ */ new Set();
    this.encodedSearch = [...this.url.searchParams].filter(([I]) => {
      if (!I) return !1;
      if (this.service === "s3") {
        if (Oe.has(I)) return !1;
        Oe.add(I);
      }
      return !0;
    }).map((I) => I.map((ne) => pt(encodeURIComponent(ne)))).sort(([I, ne], [Ie, Re]) => I < Ie ? -1 : I > Ie ? 1 : ne < Re ? -1 : ne > Re ? 1 : 0).map((I) => I.join("=")).join("&");
  }
  async sign() {
    return this.signQuery ? (this.url.searchParams.set("X-Amz-Signature", await this.signature()), this.sessionToken && this.appendSessionToken && this.url.searchParams.set("X-Amz-Security-Token", this.sessionToken)) : this.headers.set("Authorization", await this.authHeader()), {
      method: this.method,
      url: this.url,
      headers: this.headers,
      body: this.body
    };
  }
  async authHeader() {
    return [
      "AWS4-HMAC-SHA256 Credential=" + this.accessKeyId + "/" + this.credentialString,
      "SignedHeaders=" + this.signedHeaders,
      "Signature=" + await this.signature()
    ].join(", ");
  }
  async signature() {
    const e = this.datetime.slice(0, 8), r = [this.secretAccessKey, e, this.region, this.service].join();
    let n = this.cache.get(r);
    if (!n) {
      const s = await ue("AWS4" + this.secretAccessKey, e), a = await ue(s, this.region), i = await ue(a, this.service);
      n = await ue(i, "aws4_request"), this.cache.set(r, n);
    }
    return Ye(await ue(n, await this.stringToSign()));
  }
  async stringToSign() {
    return [
      "AWS4-HMAC-SHA256",
      this.datetime,
      this.credentialString,
      Ye(await ht(await this.canonicalString()))
    ].join(`
`);
  }
  async canonicalString() {
    return [
      this.method.toUpperCase(),
      this.encodedPath,
      this.encodedSearch,
      this.canonicalHeaders + `
`,
      this.signedHeaders,
      await this.hexBodyHash()
    ].join(`
`);
  }
  async hexBodyHash() {
    let e = this.headers.get("X-Amz-Content-Sha256") || (this.service === "s3" && this.signQuery ? "UNSIGNED-PAYLOAD" : null);
    if (e == null) {
      if (this.body && typeof this.body != "string" && !("byteLength" in this.body))
        throw new Error("body must be a string, ArrayBuffer or ArrayBufferView, unless you include the X-Amz-Content-Sha256 header");
      e = Ye(await ht(this.body || ""));
    }
    return e;
  }
}
async function ue(t, e) {
  const r = await crypto.subtle.importKey(
    "raw",
    typeof t == "string" ? qe.encode(t) : t,
    { name: "HMAC", hash: { name: "SHA-256" } },
    !1,
    ["sign"]
  );
  return crypto.subtle.sign("HMAC", r, qe.encode(e));
}
async function ht(t) {
  return crypto.subtle.digest("SHA-256", typeof t == "string" ? qe.encode(t) : t);
}
const ft = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
function Ye(t) {
  const e = new Uint8Array(t);
  let r = "";
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    r += ft[s >>> 4 & 15], r += ft[s & 15];
  }
  return r;
}
function pt(t) {
  return t.replace(/[!'()*]/g, (e) => "%" + e.charCodeAt(0).toString(16).toUpperCase());
}
function br(t, e) {
  const { hostname: r, pathname: n } = t;
  if (r.endsWith(".on.aws")) {
    const o = r.match(/^[^.]{1,63}\.lambda-url\.([^.]{1,63})\.on\.aws$/);
    return o != null ? ["lambda", o[1] || ""] : ["", ""];
  }
  if (r.endsWith(".r2.cloudflarestorage.com"))
    return ["s3", "auto"];
  if (r.endsWith(".backblazeb2.com")) {
    const o = r.match(/^(?:[^.]{1,63}\.)?s3\.([^.]{1,63})\.backblazeb2\.com$/);
    return o != null ? ["s3", o[1] || ""] : ["", ""];
  }
  const s = r.replace("dualstack.", "").match(/([^.]{1,63})\.(?:([^.]{0,63})\.)?amazonaws\.com(?:\.cn)?$/);
  let a = s && s[1] || "", i = s && s[2];
  if (i === "us-gov")
    i = "us-gov-west-1";
  else if (i === "s3" || i === "s3-accelerate")
    i = "us-east-1", a = "s3";
  else if (a === "iot")
    r.startsWith("iot.") ? a = "execute-api" : r.startsWith("data.jobs.iot.") ? a = "iot-jobs-data" : a = n === "/mqtt" ? "iotdevicegateway" : "iotdata";
  else if (a === "autoscaling") {
    const o = (e.get("X-Amz-Target") || "").split(".")[0];
    o === "AnyScaleFrontendService" ? a = "application-autoscaling" : o === "AnyScaleScalingPlannerFrontendService" && (a = "autoscaling-plans");
  } else i == null && a.startsWith("s3-") ? (i = a.slice(3).replace(/^fips-|^external-1/, ""), a = "s3") : a.endsWith("-fips") ? a = a.slice(0, -5) : i && /-\d$/.test(a) && !/-\d$/.test(i) && ([a, i] = [i, a]);
  return [_r[a] || a, i || ""];
}
function xr(t) {
  return function(e) {
    var r = {};
    for (var n in e)
      xt.call(e, n) && (r[n] = t(n, e[n]));
    return r;
  };
}
function Tr(t) {
  return xr(function(e, r) {
    return t(r);
  });
}
function Sr(t) {
  return function(e) {
    var r = {}, n = !1;
    for (var s in e)
      if (xt.call(e, s)) {
        var a = e[s];
        t(s, a) ? r[s] = a : n = !0;
      }
    return n ? r : e;
  };
}
var Er = Tr;
function Ar(t) {
  return Sr(t);
}
const Or = (t) => t >= 100 && t < 600, Ir = (t) => bt(
  t,
  Ar((e, r) => r !== void 0),
  Er(String)
), Rr = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    id: "axios",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set([
        "stringvalue",
        "arrayvalue",
        "multivalue"
      ]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "urlencoded",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set([
        "basic",
        "bearer",
        "apikey",
        "aws"
      ]),
      security: /* @__PURE__ */ new Set([]),
      proxy: /* @__PURE__ */ new Set([]),
      advanced: /* @__PURE__ */ new Set([])
    },
    canHandle(t) {
      var e;
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "axios"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "axios"
      }) : (e = t.security) != null && e.certificates ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "axios"
      }) : t.proxy ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: "Proxy is not supported",
        relay: "axios"
      }) : O(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "axios"
      });
    },
    execute(t) {
      const e = Ne.CancelToken.source(), r = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, n = (async () => {
        var s, a, i, o, c, u, p, T, K;
        try {
          const x = Date.now(), b = {
            url: t.url,
            method: t.method,
            headers: t.headers,
            params: t.params,
            data: (s = t.content) == null ? void 0 : s.content,
            maxRedirects: (i = (a = t.meta) == null ? void 0 : a.options) == null ? void 0 : i.maxRedirects,
            timeout: (c = (o = t.meta) == null ? void 0 : o.options) == null ? void 0 : c.timeout,
            decompress: ((p = (u = t.meta) == null ? void 0 : u.options) == null ? void 0 : p.decompress) ?? !0,
            validateStatus: null,
            cancelToken: e.token,
            responseType: "arraybuffer"
          };
          if (t.auth)
            switch (t.auth.kind) {
              case "basic":
                b.auth = {
                  username: t.auth.username,
                  password: t.auth.password
                };
                break;
              case "bearer":
                b.headers = {
                  ...b.headers,
                  Authorization: `Bearer ${t.auth.token}`
                };
                break;
              case "apikey":
                t.auth.in === "header" ? b.headers = {
                  ...b.headers,
                  [t.auth.key]: t.auth.value
                } : b.params = {
                  ...b.params,
                  [t.auth.key]: t.auth.value
                };
                break;
              case "aws": {
                const { accessKey: I, secretKey: ne, region: Ie, service: Re, sessionToken: Ft, in: Gt } = t.auth, ct = await new kr({
                  url: t.url,
                  method: t.method,
                  accessKeyId: I,
                  secretAccessKey: ne,
                  region: Ie,
                  service: Re,
                  sessionToken: Ft,
                  datetime: (/* @__PURE__ */ new Date()).toISOString().replace(/[:-]|\.\d{3}/g, ""),
                  signQuery: !1
                }).sign();
                if (Gt === "query")
                  b.url = ct.url.toString();
                else {
                  const dt = {};
                  ct.headers.forEach((Yt, Qt) => {
                    dt[Qt] = Yt;
                  }), b.headers = {
                    ...b.headers,
                    ...dt
                  };
                }
                break;
              }
            }
          const R = await Ne(b), re = Date.now();
          if (!Or(R.status))
            return w({
              kind: "version",
              message: `Invalid status code: ${R.status}`
            });
          const M = Ir(R.headers), W = M["content-type"] || M["Content-Type"] || M["CONTENT-TYPE"], Oe = {
            id: t.id,
            status: R.status,
            statusText: R.statusText,
            version: t.version,
            headers: M,
            body: St.body(R.data, W),
            meta: {
              timing: {
                start: x,
                end: re
              },
              size: {
                headers: JSON.stringify(R.headers).length,
                body: ((T = R.data) == null ? void 0 : T.length) ?? 0,
                total: JSON.stringify(R.headers).length + (((K = R.data) == null ? void 0 : K.length) ?? 0)
              }
            }
          };
          return O(Oe);
        } catch (x) {
          return Ne.isCancel(x) ? w({ kind: "abort", message: "Request cancelled" }) : Ne.isAxiosError(x) ? x.code === "ECONNABORTED" ? w({
            kind: "timeout",
            message: "Request timed out",
            phase: "response"
          }) : w({
            kind: "network",
            message: x.message
          }) : w({
            kind: "network",
            message: x instanceof Error ? x.message : "Unknown error occurred",
            cause: x
          });
        }
      })();
      return {
        cancel: async () => {
          e.cancel();
        },
        emitter: r,
        response: n
      };
    }
  }
}, Nr = {
  v1: Rr
};
var mt;
(function(t) {
  t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data";
})(mt || (mt = {}));
async function Cr(t) {
  return await A("plugin:relay|execute", { request: t });
}
async function Pr(t) {
  return await A("plugin:relay|cancel", { requestId: t });
}
const Zr = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    id: "desktop",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set([
        "stringvalue",
        "arrayvalue",
        "multivalue"
      ]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "binary",
        "multipart",
        "urlencoded",
        "stream",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set([
        "basic",
        "bearer",
        "digest",
        "oauth2",
        "apikey"
      ]),
      security: /* @__PURE__ */ new Set([
        "clientcertificates",
        "cacertificates",
        "certificatevalidation",
        "hostverification",
        "peerverification"
      ]),
      proxy: /* @__PURE__ */ new Set([
        "http",
        "https",
        "authentication",
        "certificates"
      ]),
      advanced: /* @__PURE__ */ new Set([
        "retry",
        "redirects",
        "timeout",
        "cookies",
        "keepalive",
        "tcpoptions",
        "http2",
        "http3"
      ])
    },
    canHandle(t) {
      var e;
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "desktop"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "desktop"
      }) : (e = t.security) != null && e.certificates && !this.capabilities.security.has("clientcertificates") ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "desktop"
      }) : t.proxy && !this.capabilities.proxy.has(t.proxy.url.startsWith("https") ? "https" : "http") ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: `Proxy protocol ${t.proxy.url.split(":")[0]} is not supported`,
        relay: "desktop"
      }) : O(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "desktop"
      });
    },
    execute(t) {
      const e = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, r = {
        id: t.id,
        url: t.url,
        method: t.method,
        version: t.version,
        headers: t.headers,
        params: t.params,
        content: t.content,
        auth: t.auth,
        security: t.security,
        proxy: t.proxy
      }, n = Cr(r).then((s) => {
        if (s.kind === "success") {
          const a = {
            id: s.response.id,
            status: s.response.status,
            statusText: s.response.statusText,
            version: s.response.version,
            headers: s.response.headers,
            cookies: s.response.cookies,
            body: St.body(s.response.body.body, s.response.body.mediaType),
            meta: {
              timing: {
                start: s.response.meta.timing.start,
                end: s.response.meta.timing.end
              },
              size: s.response.meta.size
            }
          };
          return O(a);
        }
        return w(s.error);
      }).catch((s) => {
        const a = {
          kind: "network",
          message: s instanceof Error ? s.message : "Unknown error occurred",
          cause: s
        };
        return w(a);
      });
      return {
        cancel: async () => {
          await Pr(t.id);
        },
        emitter: e,
        response: n
      };
    }
  }
}, jr = {
  v1: Zr
};
class Lr {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, r) {
    this.keyToValue.set(e, r), this.valueToKey.set(r, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}
class Et {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new Lr();
  }
  register(e, r) {
    this.kv.getByValue(e) || (r || (r = this.generateIdentifier(e)), this.kv.set(r, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}
class Dr extends Et {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, r) {
    typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(e, r.allowProps), super.register(e, r.identifier)) : super.register(e, r);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
}
function $r(t) {
  if ("values" in Object)
    return Object.values(t);
  const e = [];
  for (const r in t)
    t.hasOwnProperty(r) && e.push(t[r]);
  return e;
}
function Vr(t, e) {
  const r = $r(t);
  if ("find" in r)
    return r.find(e);
  const n = r;
  for (let s = 0; s < n.length; s++) {
    const a = n[s];
    if (e(a))
      return a;
  }
}
function oe(t, e) {
  Object.entries(t).forEach(([r, n]) => e(n, r));
}
function Pe(t, e) {
  return t.indexOf(e) !== -1;
}
function yt(t, e) {
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (e(n))
      return n;
  }
}
class Ur {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return Vr(this.transfomers, (r) => r.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
}
const zr = (t) => Object.prototype.toString.call(t).slice(8, -1), At = (t) => typeof t > "u", Mr = (t) => t === null, he = (t) => typeof t != "object" || t === null || t === Object.prototype ? !1 : Object.getPrototypeOf(t) === null ? !0 : Object.getPrototypeOf(t) === Object.prototype, et = (t) => he(t) && Object.keys(t).length === 0, F = (t) => Array.isArray(t), Wr = (t) => typeof t == "string", Br = (t) => typeof t == "number" && !isNaN(t), Hr = (t) => typeof t == "boolean", Kr = (t) => t instanceof RegExp, fe = (t) => t instanceof Map, pe = (t) => t instanceof Set, Ot = (t) => zr(t) === "Symbol", Xr = (t) => t instanceof Date && !isNaN(t.valueOf()), Fr = (t) => t instanceof Error, gt = (t) => typeof t == "number" && isNaN(t), Gr = (t) => Hr(t) || Mr(t) || At(t) || Br(t) || Wr(t) || Ot(t), Yr = (t) => typeof t == "bigint", Qr = (t) => t === 1 / 0 || t === -1 / 0, Jr = (t) => ArrayBuffer.isView(t) && !(t instanceof DataView), qr = (t) => t instanceof URL, It = (t) => t.replace(/\./g, "\\."), Qe = (t) => t.map(String).map(It).join("."), le = (t) => {
  const e = [];
  let r = "";
  for (let s = 0; s < t.length; s++) {
    let a = t.charAt(s);
    if (a === "\\" && t.charAt(s + 1) === ".") {
      r += ".", s++;
      continue;
    }
    if (a === ".") {
      e.push(r), r = "";
      continue;
    }
    r += a;
  }
  const n = r;
  return e.push(n), e;
};
function V(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const Rt = [
  V(At, "undefined", () => null, () => {
  }),
  V(Yr, "bigint", (t) => t.toString(), (t) => typeof BigInt < "u" ? BigInt(t) : (console.error("Please add a BigInt polyfill."), t)),
  V(Xr, "Date", (t) => t.toISOString(), (t) => new Date(t)),
  V(Fr, "Error", (t, e) => {
    const r = {
      name: t.name,
      message: t.message
    };
    return e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }, (t, e) => {
    const r = new Error(t.message);
    return r.name = t.name, r.stack = t.stack, e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }),
  V(Kr, "regexp", (t) => "" + t, (t) => {
    const e = t.slice(1, t.lastIndexOf("/")), r = t.slice(t.lastIndexOf("/") + 1);
    return new RegExp(e, r);
  }),
  V(
    pe,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (t) => [...t.values()],
    (t) => new Set(t)
  ),
  V(fe, "map", (t) => [...t.entries()], (t) => new Map(t)),
  V((t) => gt(t) || Qr(t), "number", (t) => gt(t) ? "NaN" : t > 0 ? "Infinity" : "-Infinity", Number),
  V((t) => t === 0 && 1 / t === -1 / 0, "number", () => "-0", Number),
  V(qr, "URL", (t) => t.toString(), (t) => new URL(t))
];
function Xe(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const Nt = Xe((t, e) => Ot(t) ? !!e.symbolRegistry.getIdentifier(t) : !1, (t, e) => ["symbol", e.symbolRegistry.getIdentifier(t)], (t) => t.description, (t, e, r) => {
  const n = r.symbolRegistry.getValue(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), en = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((t, e) => (t[e.name] = e, t), {}), Ct = Xe(Jr, (t) => ["typed-array", t.constructor.name], (t) => [...t], (t, e) => {
  const r = en[e[1]];
  if (!r)
    throw new Error("Trying to deserialize unknown typed array");
  return new r(t);
});
function Pt(t, e) {
  return t != null && t.constructor ? !!e.classRegistry.getIdentifier(t.constructor) : !1;
}
const Zt = Xe(Pt, (t, e) => ["class", e.classRegistry.getIdentifier(t.constructor)], (t, e) => {
  const r = e.classRegistry.getAllowedProps(t.constructor);
  if (!r)
    return { ...t };
  const n = {};
  return r.forEach((s) => {
    n[s] = t[s];
  }), n;
}, (t, e, r) => {
  const n = r.classRegistry.getValue(e[1]);
  if (!n)
    throw new Error(`Trying to deserialize unknown class '${e[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(n.prototype), t);
}), jt = Xe((t, e) => !!e.customTransformerRegistry.findApplicable(t), (t, e) => ["custom", e.customTransformerRegistry.findApplicable(t).name], (t, e) => e.customTransformerRegistry.findApplicable(t).serialize(t), (t, e, r) => {
  const n = r.customTransformerRegistry.findByName(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(t);
}), tn = [Zt, Nt, jt, Ct], vt = (t, e) => {
  const r = yt(tn, (s) => s.isApplicable(t, e));
  if (r)
    return {
      value: r.transform(t, e),
      type: r.annotation(t, e)
    };
  const n = yt(Rt, (s) => s.isApplicable(t, e));
  if (n)
    return {
      value: n.transform(t, e),
      type: n.annotation
    };
}, Lt = {};
Rt.forEach((t) => {
  Lt[t.annotation] = t;
});
const rn = (t, e, r) => {
  if (F(e))
    switch (e[0]) {
      case "symbol":
        return Nt.untransform(t, e, r);
      case "class":
        return Zt.untransform(t, e, r);
      case "custom":
        return jt.untransform(t, e, r);
      case "typed-array":
        return Ct.untransform(t, e, r);
      default:
        throw new Error("Unknown transformation: " + e);
    }
  else {
    const n = Lt[e];
    if (!n)
      throw new Error("Unknown transformation: " + e);
    return n.untransform(t, r);
  }
}, ae = (t, e) => {
  if (e > t.size)
    throw new Error("index out of bounds");
  const r = t.keys();
  for (; e > 0; )
    r.next(), e--;
  return r.next().value;
};
function Dt(t) {
  if (Pe(t, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Pe(t, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Pe(t, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
const nn = (t, e) => {
  Dt(e);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (pe(t))
      t = ae(t, +n);
    else if (fe(t)) {
      const s = +n, a = +e[++r] == 0 ? "key" : "value", i = ae(t, s);
      switch (a) {
        case "key":
          t = i;
          break;
        case "value":
          t = t.get(i);
          break;
      }
    } else
      t = t[n];
  }
  return t;
}, tt = (t, e, r) => {
  if (Dt(e), e.length === 0)
    return r(t);
  let n = t;
  for (let a = 0; a < e.length - 1; a++) {
    const i = e[a];
    if (F(n)) {
      const o = +i;
      n = n[o];
    } else if (he(n))
      n = n[i];
    else if (pe(n)) {
      const o = +i;
      n = ae(n, o);
    } else if (fe(n)) {
      if (a === e.length - 2)
        break;
      const c = +i, u = +e[++a] == 0 ? "key" : "value", p = ae(n, c);
      switch (u) {
        case "key":
          n = p;
          break;
        case "value":
          n = n.get(p);
          break;
      }
    }
  }
  const s = e[e.length - 1];
  if (F(n) ? n[+s] = r(n[+s]) : he(n) && (n[s] = r(n[s])), pe(n)) {
    const a = ae(n, +s), i = r(a);
    a !== i && (n.delete(a), n.add(i));
  }
  if (fe(n)) {
    const a = +e[e.length - 2], i = ae(n, a);
    switch (+s == 0 ? "key" : "value") {
      case "key": {
        const c = r(i);
        n.set(c, n.get(i)), c !== i && n.delete(i);
        break;
      }
      case "value": {
        n.set(i, r(n.get(i)));
        break;
      }
    }
  }
  return t;
};
function rt(t, e, r = []) {
  if (!t)
    return;
  if (!F(t)) {
    oe(t, (a, i) => rt(a, e, [...r, ...le(i)]));
    return;
  }
  const [n, s] = t;
  s && oe(s, (a, i) => {
    rt(a, e, [...r, ...le(i)]);
  }), e(n, r);
}
function sn(t, e, r) {
  return rt(e, (n, s) => {
    t = tt(t, s, (a) => rn(a, n, r));
  }), t;
}
function an(t, e) {
  function r(n, s) {
    const a = nn(t, le(s));
    n.map(le).forEach((i) => {
      t = tt(t, i, () => a);
    });
  }
  if (F(e)) {
    const [n, s] = e;
    n.forEach((a) => {
      t = tt(t, le(a), () => t);
    }), s && oe(s, r);
  } else
    oe(e, r);
  return t;
}
const on = (t, e) => he(t) || F(t) || fe(t) || pe(t) || Pt(t, e);
function cn(t, e, r) {
  const n = r.get(t);
  n ? n.push(e) : r.set(t, [e]);
}
function dn(t, e) {
  const r = {};
  let n;
  return t.forEach((s) => {
    if (s.length <= 1)
      return;
    e || (s = s.map((o) => o.map(String)).sort((o, c) => o.length - c.length));
    const [a, ...i] = s;
    a.length === 0 ? n = i.map(Qe) : r[Qe(a)] = i.map(Qe);
  }), n ? et(r) ? [n] : [n, r] : et(r) ? void 0 : r;
}
const $t = (t, e, r, n, s = [], a = [], i = /* @__PURE__ */ new Map()) => {
  const o = Gr(t);
  if (!o) {
    cn(t, s, e);
    const x = i.get(t);
    if (x)
      return n ? {
        transformedValue: null
      } : x;
  }
  if (!on(t, r)) {
    const x = vt(t, r), b = x ? {
      transformedValue: x.value,
      annotations: [x.type]
    } : {
      transformedValue: t
    };
    return o || i.set(t, b), b;
  }
  if (Pe(a, t))
    return {
      transformedValue: null
    };
  const c = vt(t, r), u = (c == null ? void 0 : c.value) ?? t, p = F(u) ? [] : {}, T = {};
  oe(u, (x, b) => {
    if (b === "__proto__" || b === "constructor" || b === "prototype")
      throw new Error(`Detected property ${b}. This is a prototype pollution risk, please remove it from your object.`);
    const R = $t(x, e, r, n, [...s, b], [...a, t], i);
    p[b] = R.transformedValue, F(R.annotations) ? T[b] = R.annotations : he(R.annotations) && oe(R.annotations, (re, M) => {
      T[It(b) + "." + M] = re;
    });
  });
  const K = et(T) ? {
    transformedValue: p,
    annotations: c ? [c.type] : void 0
  } : {
    transformedValue: p,
    annotations: c ? [c.type, T] : T
  };
  return o || i.set(t, K), K;
};
function Vt(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function _t(t) {
  return Vt(t) === "Array";
}
function un(t) {
  if (Vt(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function ln(t, e, r, n, s) {
  const a = {}.propertyIsEnumerable.call(n, e) ? "enumerable" : "nonenumerable";
  a === "enumerable" && (t[e] = r), s && a === "nonenumerable" && Object.defineProperty(t, e, {
    value: r,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function nt(t, e = {}) {
  if (_t(t))
    return t.map((s) => nt(s, e));
  if (!un(t))
    return t;
  const r = Object.getOwnPropertyNames(t), n = Object.getOwnPropertySymbols(t);
  return [...r, ...n].reduce((s, a) => {
    if (_t(e.props) && !e.props.includes(a))
      return s;
    const i = t[a], o = nt(i, e);
    return ln(s, a, o, t, e.nonenumerable), s;
  }, {});
}
class _ {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new Dr(), this.symbolRegistry = new Et((r) => r.description ?? ""), this.customTransformerRegistry = new Ur(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const r = /* @__PURE__ */ new Map(), n = $t(e, r, this, this.dedupe), s = {
      json: n.transformedValue
    };
    n.annotations && (s.meta = {
      ...s.meta,
      values: n.annotations
    });
    const a = dn(r, this.dedupe);
    return a && (s.meta = {
      ...s.meta,
      referentialEqualities: a
    }), s;
  }
  deserialize(e) {
    const { json: r, meta: n } = e;
    let s = nt(r);
    return n != null && n.values && (s = sn(s, n.values, this)), n != null && n.referentialEqualities && (s = an(s, n.referentialEqualities)), s;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, r) {
    this.classRegistry.register(e, r);
  }
  registerSymbol(e, r) {
    this.symbolRegistry.register(e, r);
  }
  registerCustom(e, r) {
    this.customTransformerRegistry.register({
      name: r,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
}
_.defaultInstance = new _();
_.serialize = _.defaultInstance.serialize.bind(_.defaultInstance);
_.deserialize = _.defaultInstance.deserialize.bind(_.defaultInstance);
_.stringify = _.defaultInstance.stringify.bind(_.defaultInstance);
_.parse = _.defaultInstance.parse.bind(_.defaultInstance);
_.registerClass = _.defaultInstance.registerClass.bind(_.defaultInstance);
_.registerSymbol = _.defaultInstance.registerSymbol.bind(_.defaultInstance);
_.registerCustom = _.defaultInstance.registerCustom.bind(_.defaultInstance);
_.allowErrorProps = _.defaultInstance.allowErrorProps.bind(_.defaultInstance);
_.serialize;
_.deserialize;
_.stringify;
_.parse;
_.registerClass;
_.registerCustom;
_.registerSymbol;
_.allowErrorProps;
var k;
(function(t) {
  t.assertEqual = (s) => s;
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(k || (k = {}));
var st;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(st || (st = {}));
const l = k.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), X = (t) => {
  switch (typeof t) {
    case "undefined":
      return l.undefined;
    case "string":
      return l.string;
    case "number":
      return isNaN(t) ? l.nan : l.number;
    case "boolean":
      return l.boolean;
    case "function":
      return l.function;
    case "bigint":
      return l.bigint;
    case "symbol":
      return l.symbol;
    case "object":
      return Array.isArray(t) ? l.array : t === null ? l.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? l.promise : typeof Map < "u" && t instanceof Map ? l.map : typeof Set < "u" && t instanceof Set ? l.set : typeof Date < "u" && t instanceof Date ? l.date : l.object;
    default:
      return l.unknown;
  }
}, d = k.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), hn = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class L extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, c = 0;
          for (; c < i.path.length; ) {
            const u = i.path[c];
            c === i.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(i))) : o[u] = o[u] || { _errors: [] }, o = o[u], c++;
          }
        }
    };
    return s(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, k.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
L.create = (t) => new L(t);
const me = (t, e) => {
  let r;
  switch (t.code) {
    case d.invalid_type:
      t.received === l.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case d.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, k.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${k.joinValues(t.keys, ", ")}`;
      break;
    case d.invalid_union:
      r = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${k.joinValues(t.options)}`;
      break;
    case d.invalid_enum_value:
      r = `Invalid enum value. Expected ${k.joinValues(t.options)}, received '${t.received}'`;
      break;
    case d.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      r = "Invalid function return type";
      break;
    case d.invalid_date:
      r = "Invalid date";
      break;
    case d.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : k.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case d.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case d.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case d.custom:
      r = "Invalid input";
      break;
    case d.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case d.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, k.assertNever(t);
  }
  return { message: r };
};
let Ut = me;
function fn(t) {
  Ut = t;
}
function Le() {
  return Ut;
}
const De = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, a = [...r, ...s.path || []], i = {
    ...s,
    path: a
  };
  let o = "";
  const c = n.filter((u) => !!u).slice().reverse();
  for (const u of c)
    o = u(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: s.message || o
  };
}, pn = [];
function h(t, e) {
  const r = De({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      Le(),
      me
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(r);
}
class N {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r)
      n.push({
        key: await s.key,
        value: await s.value
      });
    return N.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return y;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (n[a.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const y = Object.freeze({
  status: "aborted"
}), zt = (t) => ({ status: "dirty", value: t }), C = (t) => ({ status: "valid", value: t }), at = (t) => t.status === "aborted", it = (t) => t.status === "dirty", ye = (t) => t.status === "valid", $e = (t) => typeof Promise < "u" && t instanceof Promise;
var f;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(f || (f = {}));
class U {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wt = (t, e) => {
  if (ye(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new L(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function g(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => i.code !== "invalid_type" ? { message: o.defaultError } : typeof o.data > "u" ? { message: n ?? o.defaultError } : { message: r ?? o.defaultError }, description: s };
}
class v {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return X(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: X(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new N(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: X(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if ($e(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: X(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return wt(s, a);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: X(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), a = await ($e(s) ? s : Promise.resolve(s));
    return wt(n, a);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: d.custom,
        ...n(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new $({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return B.create(this, this._def);
  }
  nullable() {
    return te.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return D.create(this, this._def);
  }
  promise() {
    return de.create(this, this._def);
  }
  or(e) {
    return we.create([this, e], this._def);
  }
  and(e) {
    return ke.create(this, e, this._def);
  }
  transform(e) {
    return new $({
      ...g(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ee({
      ...g(this._def),
      innerType: this,
      defaultValue: r,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new Wt({
      typeName: m.ZodBranded,
      type: this,
      ...g(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Me({
      ...g(this._def),
      innerType: this,
      catchValue: r,
      typeName: m.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Ae.create(this, e);
  }
  readonly() {
    return Be.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const mn = /^c[^\s-]{8,}$/i, yn = /^[a-z][a-z0-9]*$/, gn = /^[0-9A-HJKMNP-TV-Z]{26}$/, vn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _n = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, wn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Je;
const kn = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, bn = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, xn = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Tn(t, e) {
  return !!((e === "v4" || !e) && kn.test(t) || (e === "v6" || !e) && bn.test(t));
}
class j extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== l.string) {
      const a = this._getOrReturnCtx(e);
      return h(
        a,
        {
          code: d.invalid_type,
          expected: l.string,
          received: a.parsedType
        }
        //
      ), y;
    }
    const n = new N();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), h(s, {
          code: d.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), h(s, {
          code: d.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? h(s, {
          code: d.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && h(s, {
          code: d.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        _n.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "email",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Je || (Je = new RegExp(wn, "u")), Je.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "emoji",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        vn.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "uuid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        mn.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "cuid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        yn.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "cuid2",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        gn.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "ulid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), h(s, {
            validation: "url",
            code: d.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        validation: "regex",
        code: d.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? xn(a).test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? Tn(e.data, a.version) || (s = this._getOrReturnCtx(e, s), h(s, {
        validation: "ip",
        code: d.invalid_string,
        message: a.message
      }), n.dirty()) : k.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: d.invalid_string,
      ...f.errToObj(n)
    });
  }
  _addCheck(e) {
    return new j({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...f.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...f.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...f.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...f.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...f.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...f.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...f.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...f.errToObj(e) });
  }
  datetime(e) {
    var r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      ...f.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...f.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...f.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...f.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...f.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...f.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...f.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...f.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, f.errToObj(e));
  }
  trim() {
    return new j({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new j({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new j({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
j.create = (t) => {
  var e;
  return new j({
    checks: [],
    typeName: m.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...g(t)
  });
};
function Sn(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, a = parseInt(t.toFixed(s).replace(".", "")), i = parseInt(e.toFixed(s).replace(".", ""));
  return a % i / Math.pow(10, s);
}
class G extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== l.number) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: d.invalid_type,
        expected: l.number,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new N();
    for (const a of this._def.checks)
      a.kind === "int" ? k.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? Sn(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_finite,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, f.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, f.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, f.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, f.toString(r));
  }
  setLimit(e, r, n, s) {
    return new G({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: f.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new G({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: f.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: f.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: f.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: f.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: f.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: f.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: f.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: f.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: f.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && k.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
G.create = (t) => new G({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class Y extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== l.bigint) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: d.invalid_type,
        expected: l.bigint,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new N();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, f.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, f.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, f.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, f.toString(r));
  }
  setLimit(e, r, n, s) {
    return new Y({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: f.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Y({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: f.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: f.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: f.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: f.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: f.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
Y.create = (t) => {
  var e;
  return new Y({
    checks: [],
    typeName: m.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...g(t)
  });
};
class ge extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== l.boolean) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.boolean,
        received: n.parsedType
      }), y;
    }
    return C(e.data);
  }
}
ge.create = (t) => new ge({
  typeName: m.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class q extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== l.date) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: d.invalid_type,
        expected: l.date,
        received: a.parsedType
      }), y;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: d.invalid_date
      }), y;
    }
    const n = new N();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), h(s, {
        code: d.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : k.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: f.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: f.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
q.create = (t) => new q({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: m.ZodDate,
  ...g(t)
});
class Ve extends v {
  _parse(e) {
    if (this._getType(e) !== l.symbol) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.symbol,
        received: n.parsedType
      }), y;
    }
    return C(e.data);
  }
}
Ve.create = (t) => new Ve({
  typeName: m.ZodSymbol,
  ...g(t)
});
class ve extends v {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.undefined,
        received: n.parsedType
      }), y;
    }
    return C(e.data);
  }
}
ve.create = (t) => new ve({
  typeName: m.ZodUndefined,
  ...g(t)
});
class _e extends v {
  _parse(e) {
    if (this._getType(e) !== l.null) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.null,
        received: n.parsedType
      }), y;
    }
    return C(e.data);
  }
}
_e.create = (t) => new _e({
  typeName: m.ZodNull,
  ...g(t)
});
class ce extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return C(e.data);
  }
}
ce.create = (t) => new ce({
  typeName: m.ZodAny,
  ...g(t)
});
class J extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return C(e.data);
  }
}
J.create = (t) => new J({
  typeName: m.ZodUnknown,
  ...g(t)
});
class H extends v {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return h(r, {
      code: d.invalid_type,
      expected: l.never,
      received: r.parsedType
    }), y;
  }
}
H.create = (t) => new H({
  typeName: m.ZodNever,
  ...g(t)
});
class Ue extends v {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.void,
        received: n.parsedType
      }), y;
    }
    return C(e.data);
  }
}
Ue.create = (t) => new Ue({
  typeName: m.ZodVoid,
  ...g(t)
});
class D extends v {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== l.array)
      return h(r, {
        code: d.invalid_type,
        expected: l.array,
        received: r.parsedType
      }), y;
    if (s.exactLength !== null) {
      const i = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (i || o) && (h(r, {
        code: i ? d.too_big : d.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (h(r, {
      code: d.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (h(r, {
      code: d.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => s.type._parseAsync(new U(r, i, r.path, o)))).then((i) => N.mergeArray(n, i));
    const a = [...r.data].map((i, o) => s.type._parseSync(new U(r, i, r.path, o)));
    return N.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new D({
      ...this._def,
      minLength: { value: e, message: f.toString(r) }
    });
  }
  max(e, r) {
    return new D({
      ...this._def,
      maxLength: { value: e, message: f.toString(r) }
    });
  }
  length(e, r) {
    return new D({
      ...this._def,
      exactLength: { value: e, message: f.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
D.create = (t, e) => new D({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ...g(e)
});
function se(t) {
  if (t instanceof S) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = B.create(se(n));
    }
    return new S({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof D ? new D({
    ...t._def,
    type: se(t.element)
  }) : t instanceof B ? B.create(se(t.unwrap())) : t instanceof te ? te.create(se(t.unwrap())) : t instanceof z ? z.create(t.items.map((e) => se(e))) : t;
}
class S extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = k.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== l.object) {
      const u = this._getOrReturnCtx(e);
      return h(u, {
        code: d.invalid_type,
        expected: l.object,
        received: u.parsedType
      }), y;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof H && this._def.unknownKeys === "strip"))
      for (const u in s.data)
        i.includes(u) || o.push(u);
    const c = [];
    for (const u of i) {
      const p = a[u], T = s.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: p._parse(new U(s, T, s.path, u)),
        alwaysSet: u in s.data
      });
    }
    if (this._def.catchall instanceof H) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const p of o)
          c.push({
            key: { status: "valid", value: p },
            value: { status: "valid", value: s.data[p] }
          });
      else if (u === "strict")
        o.length > 0 && (h(s, {
          code: d.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const p of o) {
        const T = s.data[p];
        c.push({
          key: { status: "valid", value: p },
          value: u._parse(
            new U(s, T, s.path, p)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: p in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const p of c) {
        const T = await p.key;
        u.push({
          key: T,
          value: await p.value,
          alwaysSet: p.alwaysSet
        });
      }
      return u;
    }).then((u) => N.mergeObjectSync(n, u)) : N.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return f.errToObj, new S({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var s, a, i, o;
          const c = (i = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, r, n).message) !== null && i !== void 0 ? i : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = f.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new S({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new S({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new S({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new S({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new S({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return k.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new S({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return k.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new S({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return se(this);
  }
  partial(e) {
    const r = {};
    return k.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }), new S({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return k.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof B; )
          a = a._def.innerType;
        r[n] = a;
      }
    }), new S({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Mt(k.objectKeys(this.shape));
  }
}
S.create = (t, e) => new S({
  shape: () => t,
  unknownKeys: "strip",
  catchall: H.create(),
  typeName: m.ZodObject,
  ...g(e)
});
S.strictCreate = (t, e) => new S({
  shape: () => t,
  unknownKeys: "strict",
  catchall: H.create(),
  typeName: m.ZodObject,
  ...g(e)
});
S.lazycreate = (t, e) => new S({
  shape: t,
  unknownKeys: "strip",
  catchall: H.create(),
  typeName: m.ZodObject,
  ...g(e)
});
class we extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new L(o.ctx.common.issues));
      return h(r, {
        code: d.invalid_union,
        unionErrors: i
      }), y;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const c of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, p = c._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (p.status === "valid")
          return p;
        p.status === "dirty" && !a && (a = { result: p, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((c) => new L(c));
      return h(r, {
        code: d.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
we.create = (t, e) => new we({
  options: t,
  typeName: m.ZodUnion,
  ...g(e)
});
const Ze = (t) => t instanceof xe ? Ze(t.schema) : t instanceof $ ? Ze(t.innerType()) : t instanceof Te ? [t.value] : t instanceof Q ? t.options : t instanceof Se ? Object.keys(t.enum) : t instanceof Ee ? Ze(t._def.innerType) : t instanceof ve ? [void 0] : t instanceof _e ? [null] : null;
class Fe extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.object)
      return h(r, {
        code: d.invalid_type,
        expected: l.object,
        received: r.parsedType
      }), y;
    const n = this.discriminator, s = r.data[n], a = this.optionsMap.get(s);
    return a ? r.common.async ? a._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : a._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (h(r, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const a of r) {
      const i = Ze(a.shape[e]);
      if (!i)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new Fe({
      typeName: m.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: s,
      ...g(n)
    });
  }
}
function ot(t, e) {
  const r = X(t), n = X(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === l.object && n === l.object) {
    const s = k.objectKeys(e), a = k.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const c = ot(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      i[o] = c.data;
    }
    return { valid: !0, data: i };
  } else if (r === l.array && n === l.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], c = ot(i, o);
      if (!c.valid)
        return { valid: !1 };
      s.push(c.data);
    }
    return { valid: !0, data: s };
  } else return r === l.date && n === l.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ke extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (a, i) => {
      if (at(a) || at(i))
        return y;
      const o = ot(a.value, i.value);
      return o.valid ? ((it(a) || it(i)) && r.dirty(), { status: r.value, value: o.data }) : (h(n, {
        code: d.invalid_intersection_types
      }), y);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ke.create = (t, e, r) => new ke({
  left: t,
  right: e,
  typeName: m.ZodIntersection,
  ...g(r)
});
class z extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.array)
      return h(n, {
        code: d.invalid_type,
        expected: l.array,
        received: n.parsedType
      }), y;
    if (n.data.length < this._def.items.length)
      return h(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && n.data.length > this._def.items.length && (h(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((i, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new U(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(a).then((i) => N.mergeArray(r, i)) : N.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new z({
      ...this._def,
      rest: e
    });
  }
}
z.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new z({
    items: t,
    typeName: m.ZodTuple,
    rest: null,
    ...g(e)
  });
};
class be extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.object)
      return h(n, {
        code: d.invalid_type,
        expected: l.object,
        received: n.parsedType
      }), y;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: a._parse(new U(n, o, n.path, o)),
        value: i._parse(new U(n, n.data[o], n.path, o))
      });
    return n.common.async ? N.mergeObjectAsync(r, s) : N.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof v ? new be({
      keyType: e,
      valueType: r,
      typeName: m.ZodRecord,
      ...g(n)
    }) : new be({
      keyType: j.create(),
      valueType: e,
      typeName: m.ZodRecord,
      ...g(r)
    });
  }
}
class ze extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.map)
      return h(n, {
        code: d.invalid_type,
        expected: l.map,
        received: n.parsedType
      }), y;
    const s = this._def.keyType, a = this._def.valueType, i = [...n.data.entries()].map(([o, c], u) => ({
      key: s._parse(new U(n, o, n.path, [u, "key"])),
      value: a._parse(new U(n, c, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const u = await c.key, p = await c.value;
          if (u.status === "aborted" || p.status === "aborted")
            return y;
          (u.status === "dirty" || p.status === "dirty") && r.dirty(), o.set(u.value, p.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of i) {
        const u = c.key, p = c.value;
        if (u.status === "aborted" || p.status === "aborted")
          return y;
        (u.status === "dirty" || p.status === "dirty") && r.dirty(), o.set(u.value, p.value);
      }
      return { status: r.value, value: o };
    }
  }
}
ze.create = (t, e, r) => new ze({
  valueType: e,
  keyType: t,
  typeName: m.ZodMap,
  ...g(r)
});
class ee extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.set)
      return h(n, {
        code: d.invalid_type,
        expected: l.set,
        received: n.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (h(n, {
      code: d.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (h(n, {
      code: d.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function i(c) {
      const u = /* @__PURE__ */ new Set();
      for (const p of c) {
        if (p.status === "aborted")
          return y;
        p.status === "dirty" && r.dirty(), u.add(p.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...n.data.values()].map((c, u) => a._parse(new U(n, c, n.path, u)));
    return n.common.async ? Promise.all(o).then((c) => i(c)) : i(o);
  }
  min(e, r) {
    return new ee({
      ...this._def,
      minSize: { value: e, message: f.toString(r) }
    });
  }
  max(e, r) {
    return new ee({
      ...this._def,
      maxSize: { value: e, message: f.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ee.create = (t, e) => new ee({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ...g(e)
});
class ie extends v {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.function)
      return h(r, {
        code: d.invalid_type,
        expected: l.function,
        received: r.parsedType
      }), y;
    function n(o, c) {
      return De({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Le(),
          me
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function s(o, c) {
      return De({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Le(),
          me
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: r.common.contextualErrorMap }, i = r.data;
    if (this._def.returns instanceof de) {
      const o = this;
      return C(async function(...c) {
        const u = new L([]), p = await o._def.args.parseAsync(c, a).catch((x) => {
          throw u.addIssue(n(c, x)), u;
        }), T = await Reflect.apply(i, this, p);
        return await o._def.returns._def.type.parseAsync(T, a).catch((x) => {
          throw u.addIssue(s(T, x)), u;
        });
      });
    } else {
      const o = this;
      return C(function(...c) {
        const u = o._def.args.safeParse(c, a);
        if (!u.success)
          throw new L([n(c, u.error)]);
        const p = Reflect.apply(i, this, u.data), T = o._def.returns.safeParse(p, a);
        if (!T.success)
          throw new L([s(p, T.error)]);
        return T.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ie({
      ...this._def,
      args: z.create(e).rest(J.create())
    });
  }
  returns(e) {
    return new ie({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new ie({
      args: e || z.create([]).rest(J.create()),
      returns: r || J.create(),
      typeName: m.ZodFunction,
      ...g(n)
    });
  }
}
class xe extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
xe.create = (t, e) => new xe({
  getter: t,
  typeName: m.ZodLazy,
  ...g(e)
});
class Te extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return h(r, {
        received: r.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Te.create = (t, e) => new Te({
  value: t,
  typeName: m.ZodLiteral,
  ...g(e)
});
function Mt(t, e) {
  return new Q({
    values: t,
    typeName: m.ZodEnum,
    ...g(e)
  });
}
class Q extends v {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return h(r, {
        expected: k.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return h(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), y;
    }
    return C(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e) {
    return Q.create(e);
  }
  exclude(e) {
    return Q.create(this.options.filter((r) => !e.includes(r)));
  }
}
Q.create = Mt;
class Se extends v {
  _parse(e) {
    const r = k.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== l.string && n.parsedType !== l.number) {
      const s = k.objectValues(r);
      return h(n, {
        expected: k.joinValues(s),
        received: n.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (r.indexOf(e.data) === -1) {
      const s = k.objectValues(r);
      return h(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: s
      }), y;
    }
    return C(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Se.create = (t, e) => new Se({
  values: t,
  typeName: m.ZodNativeEnum,
  ...g(e)
});
class de extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.promise && r.common.async === !1)
      return h(r, {
        code: d.invalid_type,
        expected: l.promise,
        received: r.parsedType
      }), y;
    const n = r.parsedType === l.promise ? r.data : Promise.resolve(r.data);
    return C(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
de.create = (t, e) => new de({
  type: t,
  typeName: m.ZodPromise,
  ...g(e)
});
class $ extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        h(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(n.data, a);
      return n.common.issues.length ? {
        status: "dirty",
        value: n.data
      } : n.common.async ? Promise.resolve(i).then((o) => this._def.schema._parseAsync({
        data: o,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: i,
        path: n.path,
        parent: n
      });
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const c = s.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!ye(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => ye(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({ status: r.value, value: o })) : i);
    k.assertNever(s);
  }
}
$.create = (t, e, r) => new $({
  schema: t,
  typeName: m.ZodEffects,
  effect: e,
  ...g(r)
});
$.createWithPreprocess = (t, e, r) => new $({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: m.ZodEffects,
  ...g(r)
});
class B extends v {
  _parse(e) {
    return this._getType(e) === l.undefined ? C(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
B.create = (t, e) => new B({
  innerType: t,
  typeName: m.ZodOptional,
  ...g(e)
});
class te extends v {
  _parse(e) {
    return this._getType(e) === l.null ? C(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
te.create = (t, e) => new te({
  innerType: t,
  typeName: m.ZodNullable,
  ...g(e)
});
class Ee extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === l.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ee.create = (t, e) => new Ee({
  innerType: t,
  typeName: m.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...g(e)
});
class Me extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return $e(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Me.create = (t, e) => new Me({
  innerType: t,
  typeName: m.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...g(e)
});
class We extends v {
  _parse(e) {
    if (this._getType(e) !== l.nan) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: l.nan,
        received: n.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
We.create = (t) => new We({
  typeName: m.ZodNaN,
  ...g(t)
});
const En = Symbol("zod_brand");
class Wt extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ae extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? y : a.status === "dirty" ? (r.dirty(), zt(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new Ae({
      in: e,
      out: r,
      typeName: m.ZodPipeline
    });
  }
}
class Be extends v {
  _parse(e) {
    const r = this._def.innerType._parse(e);
    return ye(r) && (r.value = Object.freeze(r.value)), r;
  }
}
Be.create = (t, e) => new Be({
  innerType: t,
  typeName: m.ZodReadonly,
  ...g(e)
});
const Bt = (t, e = {}, r) => t ? ce.create().superRefine((n, s) => {
  var a, i;
  if (!t(n)) {
    const o = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, c = (i = (a = o.fatal) !== null && a !== void 0 ? a : r) !== null && i !== void 0 ? i : !0, u = typeof o == "string" ? { message: o } : o;
    s.addIssue({ code: "custom", ...u, fatal: c });
  }
}) : ce.create(), An = {
  object: S.lazycreate
};
var m;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const On = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Bt((r) => r instanceof t, e), Ht = j.create, Kt = G.create, In = We.create, Rn = Y.create, Xt = ge.create, Nn = q.create, Cn = Ve.create, Pn = ve.create, Zn = _e.create, jn = ce.create, Ln = J.create, Dn = H.create, $n = Ue.create, Vn = D.create, Un = S.create, zn = S.strictCreate, Mn = we.create, Wn = Fe.create, Bn = ke.create, Hn = z.create, Kn = be.create, Xn = ze.create, Fn = ee.create, Gn = ie.create, Yn = xe.create, Qn = Te.create, Jn = Q.create, qn = Se.create, es = de.create, kt = $.create, ts = B.create, rs = te.create, ns = $.createWithPreprocess, ss = Ae.create, as = () => Ht().optional(), is = () => Kt().optional(), os = () => Xt().optional(), cs = {
  string: (t) => j.create({ ...t, coerce: !0 }),
  number: (t) => G.create({ ...t, coerce: !0 }),
  boolean: (t) => ge.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => Y.create({ ...t, coerce: !0 }),
  date: (t) => q.create({ ...t, coerce: !0 })
}, ds = y;
var E = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: me,
  setErrorMap: fn,
  getErrorMap: Le,
  makeIssue: De,
  EMPTY_PATH: pn,
  addIssueToContext: h,
  ParseStatus: N,
  INVALID: y,
  DIRTY: zt,
  OK: C,
  isAborted: at,
  isDirty: it,
  isValid: ye,
  isAsync: $e,
  get util() {
    return k;
  },
  get objectUtil() {
    return st;
  },
  ZodParsedType: l,
  getParsedType: X,
  ZodType: v,
  ZodString: j,
  ZodNumber: G,
  ZodBigInt: Y,
  ZodBoolean: ge,
  ZodDate: q,
  ZodSymbol: Ve,
  ZodUndefined: ve,
  ZodNull: _e,
  ZodAny: ce,
  ZodUnknown: J,
  ZodNever: H,
  ZodVoid: Ue,
  ZodArray: D,
  ZodObject: S,
  ZodUnion: we,
  ZodDiscriminatedUnion: Fe,
  ZodIntersection: ke,
  ZodTuple: z,
  ZodRecord: be,
  ZodMap: ze,
  ZodSet: ee,
  ZodFunction: ie,
  ZodLazy: xe,
  ZodLiteral: Te,
  ZodEnum: Q,
  ZodNativeEnum: Se,
  ZodPromise: de,
  ZodEffects: $,
  ZodTransformer: $,
  ZodOptional: B,
  ZodNullable: te,
  ZodDefault: Ee,
  ZodCatch: Me,
  ZodNaN: We,
  BRAND: En,
  ZodBranded: Wt,
  ZodPipeline: Ae,
  ZodReadonly: Be,
  custom: Bt,
  Schema: v,
  ZodSchema: v,
  late: An,
  get ZodFirstPartyTypeKind() {
    return m;
  },
  coerce: cs,
  any: jn,
  array: Vn,
  bigint: Rn,
  boolean: Xt,
  date: Nn,
  discriminatedUnion: Wn,
  effect: kt,
  enum: Jn,
  function: Gn,
  instanceof: On,
  intersection: Bn,
  lazy: Yn,
  literal: Qn,
  map: Xn,
  nan: In,
  nativeEnum: qn,
  never: Dn,
  null: Zn,
  nullable: rs,
  number: Kt,
  object: Un,
  oboolean: os,
  onumber: is,
  optional: ts,
  ostring: as,
  pipeline: ss,
  preprocess: ns,
  promise: es,
  record: Kn,
  set: Fn,
  strictObject: zn,
  string: Ht,
  symbol: Cn,
  transformer: kt,
  tuple: Hn,
  undefined: Pn,
  union: Mn,
  unknown: Ln,
  void: $n,
  NEVER: ds,
  ZodIssueCode: d,
  quotelessJson: hn,
  ZodError: L
});
E.object({
  version: E.number(),
  lastUpdated: E.string().datetime(),
  namespaces: E.record(E.object({
    name: E.string(),
    version: E.number(),
    createdAt: E.string().datetime(),
    updatedAt: E.string().datetime(),
    keys: E.array(E.string())
  }))
});
const He = E.object({
  schemaVersion: E.number(),
  metadata: E.object({
    createdAt: E.string().datetime(),
    updatedAt: E.string().datetime(),
    namespace: E.string(),
    encrypted: E.boolean().optional(),
    compressed: E.boolean().optional(),
    ttl: E.number().optional()
  }),
  data: E.unknown()
});
class Z {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
  }
  static new() {
    return Z.instance || (Z.instance = new Z()), Z.instance;
  }
  getFullKey(e, r) {
    return `${e}:${r}`;
  }
  notifyListeners(e, r, n) {
    const s = this.getFullKey(e, r);
    (this.listeners.get(s) || /* @__PURE__ */ new Set()).forEach((i) => i({ namespace: e, key: r, value: n }));
  }
  async set(e, r, n) {
    const s = He.parse(n);
    localStorage.setItem(this.getFullKey(e, r), _.stringify(s)), this.notifyListeners(e, r, s.data);
  }
  async getRaw(e, r) {
    const n = localStorage.getItem(this.getFullKey(e, r));
    if (!n) return;
    const s = _.parse(n);
    return He.parse(s);
  }
  async get(e, r) {
    const n = await this.getRaw(e, r);
    return n == null ? void 0 : n.data;
  }
  async has(e, r) {
    return localStorage.getItem(this.getFullKey(e, r)) !== null;
  }
  async delete(e, r) {
    const n = await this.has(e, r);
    return n && (localStorage.removeItem(this.getFullKey(e, r)), this.notifyListeners(e, r, void 0)), n;
  }
  async clear(e) {
    e ? Object.keys(localStorage).filter((n) => n.startsWith(`${e}:`)).forEach((n) => localStorage.removeItem(n)) : localStorage.clear(), this.listeners.clear();
  }
  async listNamespaces() {
    const e = /* @__PURE__ */ new Set();
    return Object.keys(localStorage).forEach((r) => {
      const [n] = r.split(":");
      e.add(n);
    }), Array.from(e);
  }
  async listKeys(e) {
    return Object.keys(localStorage).filter((r) => r.startsWith(`${e}:`)).map((r) => r.replace(`${e}:`, ""));
  }
  watch(e, r) {
    const n = this.getFullKey(e, r);
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(a), () => {
        var i;
        return (i = this.listeners.get(n)) == null ? void 0 : i.delete(a);
      }),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          var c;
          a(o), (c = this.listeners.get(n)) == null || c.delete(i);
        };
        return this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(i), () => {
          var o;
          return (o = this.listeners.get(n)) == null ? void 0 : o.delete(i);
        };
      },
      off: (s, a) => {
        var i;
        s === "change" && ((i = this.listeners.get(n)) == null || i.delete(a));
      }
    };
  }
}
const us = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    id: "browser-store",
    capabilities: /* @__PURE__ */ new Set(["permanent", "structured", "watch", "namespace"]),
    async init() {
      try {
        return O(void 0);
      } catch (t) {
        return w({
          kind: "storage",
          message: t instanceof Error ? t.message : "Unknown error",
          cause: t
        });
      }
    },
    async set(t, e, r, n) {
      try {
        const s = Z.new(), a = await s.getRaw(t, e), i = (a == null ? void 0 : a.metadata.createdAt) || (/* @__PURE__ */ new Date()).toISOString(), o = (/* @__PURE__ */ new Date()).toISOString(), c = {
          schemaVersion: 1,
          metadata: {
            createdAt: i,
            updatedAt: o,
            namespace: t,
            encrypted: n == null ? void 0 : n.encrypt,
            compressed: n == null ? void 0 : n.compress,
            ttl: n == null ? void 0 : n.ttl
          },
          data: r
        };
        return await s.set(t, e, c), O(void 0);
      } catch (s) {
        return w({
          kind: "storage",
          message: s instanceof Error ? s.message : "Unknown error",
          cause: s
        });
      }
    },
    async get(t, e) {
      try {
        const r = Z.new();
        return O(await r.get(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async has(t, e) {
      try {
        const r = Z.new();
        return O(await r.has(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async remove(t, e) {
      try {
        const r = Z.new();
        return O(await r.delete(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async clear(t) {
      try {
        return await Z.new().clear(t), O(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listNamespaces() {
      try {
        const t = Z.new();
        return O(await t.listNamespaces());
      } catch (t) {
        return w({
          kind: "storage",
          message: t instanceof Error ? t.message : "Unknown error",
          cause: t
        });
      }
    },
    async listKeys(t) {
      try {
        const e = Z.new();
        return O(await e.listKeys(t));
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    watch(t, e) {
      return Z.new().watch(t, e);
    }
  }
}, ls = {
  v1: us
};
class Ke extends pr {
  constructor(e) {
    super(e);
  }
  /**
   * Create a new Store or load the existing store with the path.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * const store = await Store.load('store.json');
   * ```
   *
   * @param path Path to save the store in `app_data_dir`
   * @param options Store configuration options
   */
  static async load(e, r) {
    const n = await A("plugin:store|load", {
      path: e,
      ...r
    });
    return new Ke(n);
  }
  /**
   * Gets an already loaded store.
   *
   * If the store is not loaded, returns `null`. In this case you must {@link Store.load load} it.
   *
   * This function is more useful when you already know the store is loaded
   * and just need to access its instance. Prefer {@link Store.load} otherwise.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * let store = await Store.get('store.json');
   * if (!store) {
   *   store = await Store.load('store.json');
   * }
   * ```
   *
   * @param path Path of the store.
   */
  static async get(e) {
    return await A("plugin:store|get_store", { path: e }).then((r) => r ? new Ke(r) : null);
  }
  async set(e, r) {
    await A("plugin:store|set", {
      rid: this.rid,
      key: e,
      value: r
    });
  }
  async get(e) {
    const [r, n] = await A("plugin:store|get", {
      rid: this.rid,
      key: e
    });
    return n ? r : void 0;
  }
  async has(e) {
    return await A("plugin:store|has", {
      rid: this.rid,
      key: e
    });
  }
  async delete(e) {
    return await A("plugin:store|delete", {
      rid: this.rid,
      key: e
    });
  }
  async clear() {
    await A("plugin:store|clear", { rid: this.rid });
  }
  async reset() {
    await A("plugin:store|reset", { rid: this.rid });
  }
  async keys() {
    return await A("plugin:store|keys", { rid: this.rid });
  }
  async values() {
    return await A("plugin:store|values", { rid: this.rid });
  }
  async entries() {
    return await A("plugin:store|entries", { rid: this.rid });
  }
  async length() {
    return await A("plugin:store|length", { rid: this.rid });
  }
  async reload() {
    await A("plugin:store|reload", { rid: this.rid });
  }
  async save() {
    await A("plugin:store|save", { rid: this.rid });
  }
  async onKeyChange(e, r) {
    return await je("store://change", (n) => {
      n.payload.resourceId === this.rid && n.payload.key === e && r(n.payload.exists ? n.payload.value : void 0);
    });
  }
  async onChange(e) {
    return await je("store://change", (r) => {
      r.payload.resourceId === this.rid && e(r.payload.key, r.payload.exists ? r.payload.value : void 0);
    });
  }
}
const hs = `${window.location.host}.hoppscotch.store`;
class P {
  constructor() {
    this.store = null, this.listeners = /* @__PURE__ */ new Map(), this.data = {};
  }
  static new() {
    return P.instance || (P.instance = new P()), P.instance;
  }
  async init() {
    if (!this.store) {
      this.store = await Ke.load(hs);
      const e = await this.store.get("data");
      this.data = e ?? {}, this.store.onChange((r, n) => {
        n && (this.data = n, this.notifyListeners());
      });
    }
  }
  notifyListeners() {
    var e;
    for (const [r, n] of this.listeners.entries()) {
      const [s, a] = r.split(":"), i = (e = this.data[s]) == null ? void 0 : e[a];
      n.forEach(
        (o) => o({
          namespace: s,
          key: a,
          value: i == null ? void 0 : i.data
        })
      );
    }
  }
  async set(e, r, n) {
    if (!this.store) throw new Error("Store not initialized");
    const s = He.parse(n);
    this.data[e] = this.data[e] || {}, this.data[e][r] = s, await this.store.set("data", this.data), await this.store.save();
  }
  async getRaw(e, r) {
    var a;
    const n = (a = this.data[e]) == null ? void 0 : a[r];
    return n ? He.parse(n) : void 0;
  }
  async get(e, r) {
    const n = await this.getRaw(e, r);
    return n == null ? void 0 : n.data;
  }
  async has(e, r) {
    var n;
    return !!((n = this.data[e]) != null && n[r]);
  }
  async delete(e, r) {
    var n;
    if (!this.store) throw new Error("Store not initialized");
    return (n = this.data[e]) != null && n[r] ? (delete this.data[e][r], Object.keys(this.data[e]).length === 0 && delete this.data[e], await this.store.set("data", this.data), await this.store.save(), !0) : !1;
  }
  async clear(e) {
    if (!this.store) throw new Error("Store not initialized");
    e ? delete this.data[e] : this.data = {}, await this.store.set("data", this.data), await this.store.save();
  }
  async listNamespaces() {
    return Object.keys(this.data);
  }
  async listKeys(e) {
    return Object.keys(this.data[e] || {});
  }
  watch(e, r) {
    const n = `${e}:${r}`;
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(a), () => {
        var i;
        return (i = this.listeners.get(n)) == null ? void 0 : i.delete(a);
      }),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          var c;
          a(o), (c = this.listeners.get(n)) == null || c.delete(i);
        };
        return this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(i), () => {
          var o;
          return (o = this.listeners.get(n)) == null ? void 0 : o.delete(i);
        };
      },
      off: (s, a) => {
        var i;
        s === "change" && ((i = this.listeners.get(n)) == null || i.delete(a));
      }
    };
  }
  async close() {
    this.store && (await this.store.close(), this.store = null, this.data = {}, this.listeners.clear());
  }
}
const fs = {
  version: { major: 1, minor: 0, patch: 0 },
  api: {
    id: "tauri-store",
    capabilities: /* @__PURE__ */ new Set(["permanent", "structured", "watch", "namespace", "secure"]),
    async init() {
      try {
        return await P.new().init(), O(void 0);
      } catch (t) {
        return w({
          kind: "storage",
          message: t instanceof Error ? t.message : "Unknown error",
          cause: t
        });
      }
    },
    async set(t, e, r, n) {
      try {
        const s = P.new(), a = await s.getRaw(t, e), i = (a == null ? void 0 : a.metadata.createdAt) || (/* @__PURE__ */ new Date()).toISOString(), o = (/* @__PURE__ */ new Date()).toISOString(), c = {
          schemaVersion: 1,
          metadata: {
            createdAt: i,
            updatedAt: o,
            namespace: t,
            encrypted: n == null ? void 0 : n.encrypt,
            compressed: n == null ? void 0 : n.compress,
            ttl: n == null ? void 0 : n.ttl
          },
          data: r
        };
        return await s.set(t, e, c), O(void 0);
      } catch (s) {
        return w({
          kind: "storage",
          message: s instanceof Error ? s.message : "Unknown error",
          cause: s
        });
      }
    },
    async get(t, e) {
      try {
        const r = P.new();
        return O(await r.get(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async has(t, e) {
      try {
        const r = P.new();
        return O(await r.has(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async remove(t, e) {
      try {
        const r = P.new();
        return O(await r.delete(t, e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async clear(t) {
      try {
        return await P.new().clear(t), O(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listNamespaces() {
      try {
        const t = P.new();
        return O(await t.listNamespaces());
      } catch (t) {
        return w({
          kind: "storage",
          message: t instanceof Error ? t.message : "Unknown error",
          cause: t
        });
      }
    },
    async listKeys(t) {
      try {
        const e = P.new();
        return O(await e.listKeys(t));
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    watch(t, e) {
      return P.new().watch(t, e);
    }
  }
}, ps = {
  v1: fs
};
function ks() {
  return window.__KERNEL_MODE__ || "web";
}
function bs(t) {
  if (t === "desktop") {
    const e = {
      info: {
        name: "desktop-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: vr.v1.api,
      relay: jr.v1.api,
      store: ps.v1.api
    };
    return window.__KERNEL__ = e, e;
  } else {
    const e = {
      info: {
        name: "web-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: ur.v1.api,
      relay: Nr.v1.api,
      store: ls.v1.api
    };
    return window.__KERNEL__ = e, e;
  }
}
export {
  Tt as MediaType,
  St as body,
  ws as content,
  ks as getKernelMode,
  bs as initKernel
};
